import React from 'react';
import { InformationCircleIcon, ExclamationTriangleIcon, XCircleIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const iconMap = {
  info: InformationCircleIcon,
  warning: ExclamationTriangleIcon,
  error: XCircleIcon,
  success: CheckCircleIcon,
  default: InformationCircleIcon,
};

const styleMap = {
  info: 'bg-sky-50 text-sky-900 border-sky-300 border-l-4',
  warning: 'bg-amber-50 text-amber-900 border-amber-300 border-l-4',
  error: 'bg-red-50 text-red-900 border-red-300 border-l-4',
  success: 'bg-emerald-50 text-emerald-900 border-emerald-300 border-l-4',
  default: 'bg-gray-50 text-gray-800 border-gray-300 border-l-4',
};

const iconStyleMap = {
  info: 'text-sky-500',
  warning: 'text-amber-500',
  error: 'text-red-500',
  success: 'text-emerald-500',
  default: 'text-gray-500',
};

export default function Callout({ type = 'default', children }) {
  const Icon = iconMap[type] || iconMap.default;
  const cardStyle = styleMap[type] || styleMap.default;
  const iconStyle = iconStyleMap[type] || iconStyleMap.default;

  return (
    <div className={`p-4 rounded-r-lg my-4 flex items-start gap-3 text-sm ${cardStyle}`}>
      <Icon className={`w-5 h-5 shrink-0 mt-0.5 ${iconStyle}`} />
      <div className="flex-1 overflow-x-auto [&>p]:m-0 [&>p:not(:last-child)]:mb-2">
        {children}
      </div>
    </div>
  );
}
